import { gql } from '@apollo/client';
import { EntityCategoryFragment } from './fragments';

export const GET_ENTITY_CATEGORIES = gql`
  query GetEntityCategories(
    $schemaIds: [ID!]!
    $term: String
    $includes: [ID!]!
    $pagination: Pagination!
  ) {
    entityCategories(
      schemaIds: $schemaIds
      term: $term
      includes: $includes
      pagination: $pagination
    ) {
      entities {
        ...EntityCategoryFields
      }
    }
  }
  ${EntityCategoryFragment}
`;
